import {
  Component,
  OnInit,
  Input,
  forwardRef,
  EventEmitter,
  Output,
  ContentChild,
  TemplateRef,
} from '@angular/core';

import {
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';

import { RxAutocompleteOptionDirective } from './rx-autocomplete-option';
import { RxAutocompleteLabelDirective } from './rx-autocomplete-label';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { RxIconModule } from '@nrwl/rx-icon';

@Component({
  selector: 'rx-autocomplete',
  templateUrl: './rx-autocomplete.component.html',
  styleUrls: ['./rx-autocomplete.component.scss'],
  imports: [CommonModule, FormsModule, RxIconModule, NgSelectModule],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RxAutocompleteComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RxAutocompleteComponent),
      multi: true,
    },
  ],
})
export class RxAutocompleteComponent implements OnInit, ControlValueAccessor, Validator {
  @Input()
  public id = 'item' + Math.random().toString(36).substring(2);

  @Input()
  public disable = false;

  @Input()
  public placeholder: string;

  @Input()
  public bindLabel = 'text';

  @Input()
  public bindValue = 'value';

  @Input()
  public clearable = true;

  @Input()
  public items: any[];

  @Input()
  public value;

  @Input()
  public searchable = true;

  @Input()
  public readonly = false;

  @Output()
  public valueChange: EventEmitter<any> = new EventEmitter();

  @Output()
  public selected: EventEmitter<any> = new EventEmitter();

  @ContentChild(RxAutocompleteOptionDirective, { static: true, read: TemplateRef })
  set optionView(value: RxAutocompleteOptionDirective) {
    this.optionTemplate = value;
  }

  @ContentChild(RxAutocompleteLabelDirective, { static: true, read: TemplateRef })
  set labelView(value: RxAutocompleteLabelDirective) {
    this.labelTemplate = value;
  }

  public optionTemplate: RxAutocompleteOptionDirective | any;
  public labelTemplate: RxAutocompleteLabelDirective | any;

  public isRequired = false;
  public isRequiredChecked = false;

  public control: FormControl;

  public onChange = (value: any) => {};
  public onTouched = () => {};

  constructor() {}

  public ngOnInit() {}

  public valueSelected(event) {
    if (event !== null && event !== undefined) {
      this.onChange(event);
      this.valueChange.emit(event);
    }
  }

  public clearValue() {
    this.onChange(null);
    this.valueChange.emit(null);
  }

  // Register for change
  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  // Register for touch/click
  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // Update the model and changes
  public writeValue(value: string): void {
    if (this.value !== value && (!!this.value || !!value)) {
      this.value = value;
      this.onChange(this.value);
    }
  }

  public isValid(): boolean {
    return this.control && !this.control.pending && !this.control.errors && !this.control.invalid;
  }

  // validate
  public validate(control: FormControl): ValidationErrors | any {
    this.control = control;

    // TODO
    if (!this.isRequiredChecked) {
      this.isRequiredChecked = true;
      this.isRequired = this.control.errors && this.control.errors['required'];
    }

    return control.valid ? null : control.errors;
  }

  public selectedItem(val: any) {
    this.selected.emit(val);
  }
}
